import numberToWords from 'number-to-words';

export default function (value) { //eslint-disable-line
  let digit = numberToWords.toWords(value);
  digit = digit.replace('-', ' ');
  return digit;
}



// WEBPACK FOOTER //
// ./src/js/filters/written-digits.js